import React, { useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        <div className="h-4 w-24 bg-white/10 animate-pulse rounded-md" />
        <div className="h-4 w-32 bg-white/10 animate-pulse rounded-md" />
        <div className="h-4 w-20 bg-white/10 animate-pulse rounded-md" />
      </div>;
  }
  return <nav className="flex flex-col gap-2">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-white/80 hover:text-white transition-colors font-light w-fit" data-index={i}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function Alatunniste() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            const targetY = element.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({
              top: targetY,
              behavior: "smooth"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <footer id="alatunniste" ref={ref} className={cn("dark bg-[hsl(220_45%_15%)] text-white py-16 px-6 md:px-12 lg:px-24 transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="max-w-7xl mx-auto">
        
        <div className="mb-12 text-center md:text-left">
          <span className="font-serif text-sm tracking-wider text-white/60 uppercase">DIALOGI MEDIATUOTANTO</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-24">
          
          <div className="flex flex-col gap-6">
            <Link to="/" className="block w-fit">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="text-white/80 leading-relaxed max-w-sm font-light">Tarinasi ansaitsee tulla kerrotuksi.</p>
          </div>

          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-4">
              <h3 className="font-serif text-lg text-white/90">Navigaatio</h3>
              <MenuProvider menu_id="49">
                <FooterMenu />
              </MenuProvider>
            </div>
          </div>

          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-4">
              <h3 className="font-serif text-lg text-white/90">Yhteystiedot</h3>
              <div className="flex flex-col gap-2 text-white/80 font-light">
                <p>Dialogi Mediatuotanto</p>
                <p>+358445903149</p>
                <Link to="mailto:tmiheikkivuorinen@gmail.com" className="hover:text-white transition-colors w-fit">info@dialogimediatuotanto.com</Link>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-white/10" />

        
        <div className="text-center">
          <p className="text-xs text-white/40 font-light tracking-wide">
            &copy; {new Date().getFullYear()} Dialogi Mediatuotanto. Kaikki oikeudet pidätetään.
          </p>
        </div>
      </div>
    </footer>;
}